import { render } from "./VabeneCouponList.vue?vue&type=template&id=5438aa58&ts=true"
import script from "./VabeneCouponList.vue?vue&type=script&lang=ts"
export * from "./VabeneCouponList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__